import { render, staticRenderFns } from "./SendToRobotDialog.vue?vue&type=template&id=1cf4cb5d&scoped=true&"
import script from "./SendToRobotDialog.vue?vue&type=script&lang=ts&"
export * from "./SendToRobotDialog.vue?vue&type=script&lang=ts&"
import style0 from "./SendToRobotDialog.vue?vue&type=style&index=0&id=1cf4cb5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf4cb5d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/builds/3ce44491/1/fsi-lab/soft/app/robot-config/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VDialog,VFlex,VSelect,VTextField})
